import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/auth";

import { CircularProgress } from "@mui/material";
import { AccountMenuProps, MenuKey } from "./types";
import { AccountMenuView } from "./view";

type ComponentType = React.FC<AccountMenuProps>;
export const AccountMenu: ComponentType = () => {
    const [active, setActive] = useState<MenuKey>("card");
    const { user, logout, isLoading } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate("/login");
    };

    if (isLoading) {
        return <CircularProgress />;
    }

    return (
        <AccountMenuView
            active={active}
            user={user}
            setActive={setActive}
            handleLogout={handleLogout}
        />
    );
};
